export default __webpack_public_path__ + "static/media/PIM.c2eb22d0.png";